// extracted by mini-css-extract-plugin
export default {"gridBlock":"grid-block_gridBlock__5FRKF","top":"grid-block_top__pM4Bh","title":"grid-block_title__Zg1dJ","bottom":"grid-block_bottom__0cYv+"};